import React, { RefObject, useCallback } from 'react';

interface ScrollPosition {
    scrollY: number;
}

export const useScrollPosition = (
    scrollRef?: RefObject<HTMLElement | null>,
): ScrollPosition => {
    const [scrollPosition, setScrollPosition] = React.useState<ScrollPosition>({
        scrollY: 0,
    });

    const handleScroll = useCallback(() => {
        const scrollElement = scrollRef?.current;
        if (scrollElement) {
            setScrollPosition({ scrollY: scrollElement.scrollTop });
        } else {
            setScrollPosition({ scrollY: window.scrollY });
        }
    }, [scrollRef]);

    React.useEffect(() => {
        const target = scrollRef?.current || window;

        if (target) {
            target.addEventListener('scroll', handleScroll, { passive: true });
        }
        return () => {
            if (target) {
                target.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll, scrollRef]);

    return scrollPosition;
};
